import {
  benefitAndVoucherManagementGetFlightSegmentCouponListSchema,
  type BenefitAndVoucherManagementGetFlightSegmentCouponList
} from '@/models/api/benefit-and-voucher-management-get-flight-segment-coupon-list'
import {
  benefitAndVoucherManagementRedeemBenefitsSchema,
  type BenefitAndVoucherManagementRedeemBenefits
} from '@/models/api/benefit-and-voucher-management-redeem-benefits'
import type { TravelAssistantGetCourtesyRequest } from '@/models/api/travel-assistant-get-courtesy-request'
import {
  TravelAssistantGetCourtesyResponse,
  travelAssistantGetCourtesyResponseSchema
} from '@/models/api/travel-assistant-get-courtesy-response'
import type { TravelAssistantGetFlightSegmentCouponListRequest } from '@/models/api/travel-assistant-get-flight-segment-coupon-list-request'
import type { TravelAssistantGetListRequest } from '@/models/api/travel-assistant-get-list-request'
import {
  travelAssistantListSchema,
  type TravelAssistantList
} from '@/models/api/travel-assistant-list'
import type { TravelAssistantRedeemBenefitsRequest } from '@/models/api/travel-assistant-redeem-benefits-request'
import {
  apiValidator,
  type ApiFactory,
  type ApiRequestConfig,
  type ApiResponse
} from '~library/services'

export default class TravelAssistantApi {
  constructor(private api: ApiFactory) {}
  /**
   * API 差旅秘書 - 取得代辦禮遇安排清單
   * https://hackmd.io/jSX7ZG8_Rdiak3eSb40XGg
   */
  @apiValidator(travelAssistantListSchema.array())
  getAgentArrangementList(
    data: TravelAssistantGetListRequest,
    config?: ApiRequestConfig
  ): Promise<ApiResponse<TravelAssistantList[]>> {
    return this.api.post('/TravelAssistant/GetList', data, config)
  }

  /**
   * API 差旅秘書 - 查詢差旅人行程資訊
   * https://hackmd.io/_QBDEOqhS5iWk83jSlOBBQ
   */
  @apiValidator(travelAssistantGetCourtesyResponseSchema)
  getQueryCourtesyArrangements(
    data: TravelAssistantGetCourtesyRequest
  ): Promise<ApiResponse<TravelAssistantGetCourtesyResponse>> {
    return this.api.post('/TravelAssistant/QueryCourtesyArrangements', data, {
      headers: {
        ignoreRtnCodeError: ['3']
      }
    })
  }

  /**
   * API 差旅秘書 - 取得航段可使用的禮遇項目清單
   * https://hackmd.io/Ws5SM7VhSiq6H7XMgk6DFQ
   */
  @apiValidator(
    benefitAndVoucherManagementGetFlightSegmentCouponListSchema.array()
  )
  getFlightSegmentCouponList(
    query: TravelAssistantGetFlightSegmentCouponListRequest,
    config?: ApiRequestConfig
  ): Promise<
    ApiResponse<BenefitAndVoucherManagementGetFlightSegmentCouponList[]>
  > {
    return this.api.post(
      'TravelAssistant/GetFlightSegmentCouponList',
      query,
      config
    )
  }

  /**
   * API 差旅秘書 - 代辦禮遇安排兌換
   * https://hackmd.io/P67AUJVtRveJS2l3rrYHzg
   */
  @apiValidator(benefitAndVoucherManagementRedeemBenefitsSchema)
  assignAndRedeemBenefits(
    query: TravelAssistantRedeemBenefitsRequest
  ): Promise<ApiResponse<BenefitAndVoucherManagementRedeemBenefits>> {
    return this.api.post('TravelAssistant/AssignAndRedeemBenefits', query, {
      headers: {
        ignoreRtnCodeError: ['68']
      }
    })
  }
}
